#### New limitations for hirer-scoped webhook subscriptions

**Why is this changing?**

The default [webhook subscription] type is partner-scoped: configured endpoints will receive events for all SEEK hirers the partner has a relationship with.

Webhook subscriptions can also be hirer-scoped.
These subscriptions will only receive events for one hirer (or no events, if the relationship is later disabled).

Historically, no limitations applied to hirer-scoped subscriptions.
This has resulted in some integrations which use an individual webhook subscription for every combination of hirer and event type.
Integrations configured in this way pose problems because:

- The additional onboarding step of configuring webhooks can go wrong, meaning the integration doesn’t work for the hirer.
  When issues like this occur, it can cost hours of support time on any side: the partner, the hirer, or SEEK.
- When many webhook subscriptions exist, operational activities — like webhook replays, or looking for missed webhooks using the Developer Dashboard — become significantly more complicated for SEEK & partners.
  As a result, if an incident occurs, it is much more likely a hirer in such an integration will e.g. miss some of their applications, or have them be more delayed than otherwise required.

[webhook subscription]: /events/webhooks

**What is changing?**

From October 1, 2025, any new partners, or existing partners not making use of hirer-scoped webhooks for non-test hirers, will not be able to make more than 20 hirer-scoped webhooks.

Existing partners using this functionality will not be affected.

**What change is required for partners?**

No immediate change is required.
This guidance is to formally deprecate the functionality.
However, SEEK recognises that this change may be inconvenient and has no immediate plans to break existing integrations.
SEEK will work with partners over time to come to a sustainable solution for their integration.
